import Td from "./Td";
import { Draggable, Droppable } from "react-beautiful-dnd";
import { motion, AnimatePresence } from "framer-motion";

const Tbody = ({ tableData = [], isOrdering = true, tableActionDropdownContainer }) => {
  return (
    <Droppable droppableId="table-list" isDropDisabled={isOrdering}>
      {(provided) => (
        <tbody className="text-sidebar text-sm font-medium" {...provided.droppableProps} ref={provided.innerRef}>
          <AnimatePresence initial={false}>
            {tableData.map((item, index) => (
              <Draggable key={item._id} draggableId={item._id.toString()} index={index} isDragDisabled={isOrdering}>
                {(provided, snapshot) => (
                  <tr
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    style={{ ...(provided.draggableProps?.style || {}) }}
                    className="border-b border-border-color last:border-b-0 hover:bg-slate-100"
                  >
                    {item.rowData.map((itemData, i) => (
                      <td key={itemData?._id + i} className={itemData.tdClasses || ""}>
                        <motion.div layout initial={{ opacity: 0, y: 2 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -4 }}>
                          <Td
                            data={itemData}
                            align={itemData?.align}
                            actionData={itemData.actionData}
                            functions={itemData?.functions}
                            onClick={itemData?.onClick}
                            checkboxChecked={itemData.checked || false}
                            tableActionDropdownContainer={tableActionDropdownContainer}
                            onCheckboxChange={() => (itemData.onCheckboxChange ? itemData.onCheckboxChange(itemData.itemDetails || {}) : () => {})}
                          />
                        </motion.div>
                      </td>
                    ))}
                  </tr>
                )}
              </Draggable>
            ))}
          </AnimatePresence>
          {provided.placeholder}
        </tbody>
      )}
    </Droppable>
  );
};

export default Tbody;
